import cpfcnpj from './cpfcnpj'
import datebefore from './datebefore'

/**
 * Array de custom validators para estender as validações padrão.
 */
export default [
  {
    name: 'cpfcnpj',
    validator: cpfcnpj
  },
  {
    name: 'datebefore',
    validator: datebefore
  }
]
